module.exports = __webpack_public_path__ + "static/awaludin-58be1c6c9ae1b5e7134084067c8dcf55.png";